module.exports = __webpack_public_path__ + "c4dbab27152ddde984e7efa4214a5656.svg";